// Corrections the coach logged during the session — spoken once, kept here so
// they can be reread afterwards without replaying the whole conversation.

export default function CorrectionFeed({ corrections }) {
  return (
    <div className="flex max-h-72 flex-col rounded-xl border border-slate-800 bg-slate-900/40">
      <h2 className="px-4 pb-1 pt-3 text-xs font-semibold uppercase tracking-wider text-slate-400">
        Corrections
        {corrections.length > 0 && (
          <span className="ml-1.5 text-slate-500">({corrections.length})</span>
        )}
      </h2>

      <div className="thin-scroll flex-1 overflow-y-auto px-2 pb-2">
        {corrections.length === 0 ? (
          <p className="px-2 py-2 text-xs text-slate-600">
            Nothing to fix yet.
          </p>
        ) : (
          corrections.map((c, i) => (
            <div key={i} className="mb-1 rounded-lg bg-slate-900/60 px-3 py-2">
              <div className="text-xs text-rose-300/80 line-through">{c.original}</div>
              <div className="text-sm text-emerald-300">{c.corrected}</div>
              {c.note && (
                <div className="mt-0.5 text-[11px] text-slate-500">{c.note}</div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
